import useBoolean from 'app/hooks/useBoolean';
import { KeyEnum } from 'app/hooks/useKeyBinder';
import { CheckedIcon } from 'assets/icons';
import { max } from 'lodash';
import { useEffect, useState } from 'react';
import { isValidPick, isValidYear, toDate } from './utils';

export default function YearPicker({
  value,
  onChange,
  month,
  minDate,
  maxDate,
}: {
  month: number;
  value?: number;
  maxDate?: Date;
  minDate?: Date;
  onChange: (d: Date) => void;
}) {
  const [year, setYear] = useState<number | undefined>();
  const { value: editMode, setTrue: setEditMode, setFalse } = useBoolean(false);
  const [isValid, setIsValid] = useState<boolean>(true);

  useEffect(() => {
    setYear(value);
    if (value) {
      let d = toDate(1, month, value);
      setIsValid(isValidYear(value, minDate, maxDate));
    }
  }, [value]);
  const onSelect = () => {
    if (year && isValid) {
      const newDate = toDate(1, month, year);
      let d = minDate && newDate < minDate ? minDate : newDate;
      if (d instanceof Date && !isNaN(d as any)) {
        setFalse();
        onChange(d);
      }
    }
  };

  return (
    <div
      className={`w-24 flex items-center border ${editMode ? 'bg-white' : ''}`}
    >
      {!editMode && (
        <div
          onClick={setEditMode}
          className="cursor-pointer font-semibold rounded flex-1 flex items-center gap-1  py-1 px-2 justify-center"
        >
          {year}
        </div>
      )}
      {editMode && (
        <>
          <input
            autoFocus={true}
            onBlur={onSelect}
            onKeyDown={(e) => {
              if (e.key === KeyEnum.ENTER) {
                e.stopPropagation();
                e.preventDefault();
                onSelect();
              }

              if (e.key === KeyEnum.ESCAPE) {
                e.stopPropagation();
                e.preventDefault();
                setYear(value);
                setFalse();
                if (value) {
                  onChange(
                    toDate(minDate ? minDate.getDate() + 1 : 1, month, value),
                  );
                }
              }
            }}
            maxLength={4}
            className="focus:outline-none font-semibold rounded flex-1 text-center gap-1  py-1 px-2 w-1 justify-center"
            value={year}
            onChange={(e) => {
              if (!isNaN(+e.target.value)) {
                setYear(+e.target.value);
                setIsValid(isValidYear(+e.target.value, minDate, maxDate));
              }
            }}
          />

          <div onClick={onSelect} className="cursor-pointer p-2">
            {isValid && <CheckedIcon className="w-3 h-3" />}
            {!isValid && <div className="w-2 h-2 rounded-full bg-red-200" />}
          </div>
        </>
      )}
    </div>
  );
}

/// min Date 10 / 1 / 2000
